import React from 'react';

import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';

const SpaceSettingsForgeAppsRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-SpaceSettingsForgeAppsRouteComponent" */ './SpaceSettingsForgeAppsRouteComponent.tsx'
		),
});

export const SpaceSettingsForgeAppsRoute: {
	({
		params: { appId, forgeManifestRoute, envId, spaceKey },
	}: {
		params: {
			appId: any;
			forgeManifestRoute: any;
			envId: any;
			spaceKey: any;
		};
	}): React.JSX.Element;
	NAVIGATION_PARAMS({
		name,
		params: { spaceKey, appId, envId },
	}: {
		name: any;
		params: {
			spaceKey: any;
			appId: any;
			envId: any;
		};
	}): {
		Screen: {
			screenEvent: {
				name: string;
				id: any;
				attributes: {
					appId: any;
					envId: any;
				};
			};
			pageState: {
				spaceKey: any;
				routeName: any;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: any;
			disableMinWidth: boolean;
		};
	};
} = ({
	params: { appId, forgeManifestRoute, envId, spaceKey },
}: {
	params: {
		appId: any;
		forgeManifestRoute: any;
		envId: any;
		spaceKey: any;
	};
}): React.JSX.Element => (
	<SpaceSettingsForgeAppsRouteComponent
		spaceKey={spaceKey}
		appId={appId}
		envId={envId}
		forgeManifestRoute={forgeManifestRoute}
	/>
);

SpaceSettingsForgeAppsRoute.NAVIGATION_PARAMS = ({
	name,
	params: { spaceKey, appId, envId },
}: {
	name: any;
	params: {
		spaceKey: any;
		appId: any;
		envId: any;
	};
}): {
	Screen: {
		screenEvent: {
			name: string;
			id: any;
			attributes: {
				appId: any;
				envId: any;
			};
		};
		pageState: {
			spaceKey: any;
			routeName: any;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: any;
		disableMinWidth: boolean;
	};
} => ({
	Screen: {
		screenEvent: { name: 'spaceSettingsForgeApps', id: spaceKey, attributes: { appId, envId } },
		pageState: { spaceKey, routeName: name },
	},
	MainLayout: {
		navView: CONTAINER_ADMIN_HOME_ID,
		spaceKey,
		disableMinWidth: true,
	},
});
